import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/contracts')({
  staticData: { breadcrumb: 'Contracts', breadcrumbKey: 'K_BREADCRUMB_CONTRACTS' },
});
